import getConfig from 'next/config';

import type { Links } from '../../interfaces/offers';
import { isServer } from '../../utils/isServer';

const baseUrl = isServer ? process.env.WEB_PATH : getConfig().publicRuntimeConfig.webPath;

export const getLeasingLinks = (): Links => ({
  clickLink: `${baseUrl}/biznes-leasing/`,
});
